import { Badge, Icon } from "@playerelite/ui";
import type { BadgeProps, IconName } from "@playerelite/ui";
import { AttractorContentType } from "../types";

/** Badge styling per content type, matching the Storybook Kiosk Attractor Campaigns design. */
export const CONTENT_TYPE_META: Record<
  AttractorContentType,
  { label: string; variant: BadgeProps["variant"]; icon: IconName }
> = {
  General: { label: "General", variant: "neutral", icon: "chat" },
  Game: { label: "Game", variant: "primary", icon: "gamepad" },
  Promotion: { label: "Promotion", variant: "warning", icon: "tag" },
};

/** Renders nothing for attractors saved before content types existed. */
export const ContentTypeBadge = ({
  contentType,
}: {
  contentType: AttractorContentType | null | undefined;
}) => {
  if (!contentType) return null;
  const meta = CONTENT_TYPE_META[contentType];
  return (
    <Badge
      variant={meta.variant}
      startIcon={<Icon name={meta.icon} size="xs" />}
      className="shrink-0"
    >
      {meta.label}
    </Badge>
  );
};

export const LinkedPromotionBadge = ({
  contentType,
  name,
}: {
  contentType: AttractorContentType | null | undefined;
  name: string;
}) => (
  <Badge
    variant="info"
    className="w-fit max-w-full"
    startIcon={
      <Icon
        name={contentType ? CONTENT_TYPE_META[contentType].icon : "tag"}
        size="xs"
      />
    }
    title={name}
  >
    <span className="truncate">{name}</span>
  </Badge>
);

export const GamingContentBadge = () => (
  <Badge variant="violet" startIcon={<Icon name="gamepad" size="xs" />}>
    Gaming only
  </Badge>
);
